// ── EDIT THESE BEFORE LAUNCH ─────────────────────────────────────────────
// Replace every value marked [ ... ] with your real business details.
// These are used across the site + the Privacy Policy and Terms pages.

export const BUSINESS = {
  brandName: "Guardian Advisory",
  legalName: "Guardian Advisory Group LLC", // [confirm your exact legal entity name]
  domain: "guardianmcahelp.com", // [confirm launch domain]
  addressLine: "80 Broad Street", // e.g. 123 Main St, Suite 200
  cityStateZip: "New York, NY 10005", // e.g. Austin, TX 78701
  phoneDisplay: "(332) 230-1915",
  phoneHref: "tel:+13322301915",
  privacyEmail: "privacy@guardianmcahelp.com", // [confirm]
  supportEmail: "info@guardianmcahelp.com", // [confirm]
  governingState: "New York", // e.g. Texas — used in Terms governing law
  calendlyUrl: "https://calendly.com/john-funding/guardian-advisory",
  lastUpdated: "June 15, 2026",
};
